module.exports = __webpack_public_path__ + "static/media/Monday_Step2_Image11.ad0ea684.jpg";